window.$ = require('jquery')
window.JQuery = require('jquery')
window.PrismJs = require('prismjs')

import chroma from "chroma-js";
import helpers from './helpers'
import arbo from './navigation'

window.chartColors = function(count){

    let colors = chroma
        .scale(["#9e0142", "#a40743", "#a90d45", "#af1346", "#b41947", "#ba2049", "#bf264a", "#c52c4b", "#ca324c", "#d0384e", "#d53e4f", "#d8434e", "#db474d", "#de4c4b", "#e1514a", "#e55649", "#e85a48", "#eb5f47", "#ee6445", "#f16844", "#f46d43", "#f57346", "#f67a49", "#f7814c", "#f8874f", "#f98e52", "#f99455", "#fa9b58", "#fba15b", "#fca85e", "#fdae61", "#fdb365", "#fdb869", "#fdbd6e", "#fdc272", "#fec776", "#fecc7a", "#fed17e", "#fed683", "#fedb87", "#fee08b", "#fee390", "#fee695", /*"#fee99b", "#feeca0", "#fff0a5", "#fff3aa", "#fff6af", "#fff9b5", "#fffcba", "#ffffbf", "#fdfebb", "#fafdb7", "#f8fcb3", "#f5fbaf", "#f3faab", "#f0f9a8", "#eef8a4", "#ebf7a0", "#e9f69c", "#e6f598", "#e0f399",*/ "#daf09a", "#d4ee9c", "#ceeb9d", "#c8e99e", "#c3e79f", "#bde4a0", "#b7e2a2", "#b1dfa3", "#abdda4", "#a4daa4", "#9dd8a4", "#96d5a4", "#8fd2a4", "#89d0a5", "#82cda5", "#7bcaa5", "#74c7a5", "#6dc5a5", "#66c2a5", "#61bca7", "#5cb6aa", "#56b1ac", "#51abaf", "#4ca5b1", "#479fb3", "#4299b6", "#3c94b8", "#378ebb", "#3288bd", "#3682ba", "#3b7db8", "#3f77b5", "#4471b2", "#486cb0", "#4c66ad", "#5160aa", "#555aa7", "#5a55a5", "#5e4fa2"].reverse())
        .domain([0,0.25,1])
        .mode('lch')
        .colors(count)

    return colors;
}

String.prototype.escapeHTML = function() {
    return this.replace(/&amp;/g, "&").replace(/(<([^>]+)>)/ig,"");
}
String.prototype.strUcFirst = function(){return (this+'').charAt(0).toUpperCase()+this.substr(1);}


window._isEmpty = function(value){
    //JSON.stringify(item)
    return JSON.stringify(value) == "[]" || JSON.stringify(value) == "{}" || JSON.stringify(value) == "";
}


window.$acl = function (user=null, aclString, id=null) {
    if(user !== null) {
        let acl = user.acl
        //console.log("ACL", user.acl)
        if(user.role_level == 1) {
            return true;
        }
        if(aclString != 'is_super_admin') {
            if( typeof acl !== 'undefined') {
                if( id !== null ) {
                    if( ((acl['accepted'].includes(aclString) || acl['accepted'].includes(aclString+'.'+id)) && (acl['denied'].includes(aclString) === false && acl['denied'].includes(aclString+'.'+id) === false )) ) {
                        return true;
                    }
                }else{
                    if( acl['accepted'].includes(aclString) && acl['denied'].includes(aclString) === false ) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
}



import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import axios from 'axios'
import { store } from './store.js';

store.dispatch("load").then(() => {

});

var days_week = [
    {id:'monday', name:'Lundi'},
    {id:'tuesday', name:'Mardi'},
    {id:'wednesday', name:'Mercredi'},
    {id:'thursday', name:'Jeudi'},
    {id:'friday', name:'Vendredi'},
    {id:'saturday', name:'Samedi'},
    {id:'sunday', name:'Dimanche'}
];

router.beforeEach(function (to, from, next) {

    //console.log('before route IN');

    if (to.meta && to.meta.permissions) {

        //console.log('before route - first if');
        let isAclChecked = true;
        let roles = to.meta.permissions.roles
        let acl = (to.meta.acl) ? to.meta.acl : null;
        let permissions = to.meta.permissions.permissions
        let authenticated = to.meta.authenticated ? true : false
        let clientIsOptional = to.meta.clientIsOptional ? true : false

        // Route ACL Check
        if(acl !== null && store.state.user !== null){
            if( Array.isArray(acl) ) {
                let checkAclArray = false;
                acl.forEach(function(item){
                    if( window.$acl(store.state.user,item) ) {
                        checkAclArray = true;
                    }
                });
                if( !checkAclArray ) {
                    isAclChecked = false;
                }
            }else{
                if( !window.$acl(store.state.user,acl) ) {
                    isAclChecked = false;
                }
            }
        }

        if(!isAclChecked) { // IF NOT AUTHORIZE TO ACCESS
            console.log('Access to ' + to.fullPath + ' route is not authorize');
            next('/dashboard');
        }else{
            if( authenticated == store.getters.isLoggedIn ){
                if( !clientIsOptional && !store.getters.scope ){
                    next('/switch-scope');
                }else{
                    next();
                }
            }else{
                store.dispatch("user").then(() => {
                    if( !clientIsOptional && !store.getters.scope ){
                        next('/switch-scope');
                    }else{
                        next();
                    }
                }).catch(e => {
                    next('/login');
                });
            }
        }
    } else {
        next();
    }
})

Vue.prototype.$navigation = arbo;

// *************** INJECT ACL METHOD IN CLASS VUE ***************
Vue.prototype.$aclInterfaceValidator = function (aclString, id=null) {
    let user = store.state.user;
    if (typeof aclString === 'string' || aclString instanceof String)
    {
        return window.$acl(user, aclString, id);
    }else{
        var check = 0;
        for(let item of aclString){
            check += window.$acl(user, item, id) ? 1 : 0;
        }
        if( check >= aclString.length )
        {
            return true;
        }
    }
    return false;
}
// *************** END INJECT ACL METHOD IN CLASS VUE ***************

import {Tabs, Tab} from 'vue-tabs-component';
import Multiselect from 'vue-multiselect';
import VueResource from 'vue-resource';

import ShippingType from './components/form/ShippingType.vue'
import DatagridSort from './components/DatagridSort.vue'
import Icon from './components/Icon.vue'
import BreadCrumb from './components/Breadcrumb.vue'
import OrderStatus from './components/OrderStatus.vue'
import Compare from './components/Compare.vue'
import Checked from './components/Checked.vue'
import Published from './components/Published.vue'
import ProductType from './components/ProductType.vue'
import Date from './components/Date.vue'
import Datetime from './components/Datetime.vue'
import Schedule from './components/Schedule.vue'
import Active from './components/Active.vue'
import Acl from './components/Acl.vue'
import AclAuthorizations from './components/AclAuthorizations.vue'
import Button from './components/Button.vue'
import NoResults from './components/NoResults.vue'
import Filters from './components/Filters.vue'
import AdvancedFilters from './components/AdvancedFilters.vue'
import WidgetDropdown from './components/WidgetDropdown.vue'
import NoticePublished from './components/NoticePublished.vue'
import FormGallery from './components/form/Gallery.vue'
import FormFile from './components/form/File.vue'
import FormFileImport from './components/form/FileImport.vue'
import FormToggle from './components/form/Toggle.vue'
import FormPublicationState from './components/form/PublicationState.vue'
import FormDate from './components/form/Date.vue'
import FormDateX from './components/form/DateX.vue'
import FormDatetime from './components/form/Datetime.vue'
import FormMedias from './components/form/Medias.vue'
import FormCode from './components/form/Code.vue'
import FormEditor from './components/form/Editor.vue'
import FormText from './components/form/Text.vue'
import FormAddress from './components/form/Address.vue'
import FormBranch from './components/form/Branch.vue'
import FormBarcode from './components/form/Barcode.vue'
import FormTime from './components/form/Time.vue'
import FormPhone from './components/form/Phone.vue'
import FormSort from './components/form/Sort.vue'
import FormNumeric from './components/form/Numeric.vue'
import FormNumber from './components/form/Number.vue'
import FormTextarea from './components/form/Textarea.vue'
import FormHtml from './components/form/Html.vue'
import FormPassword from './components/form/Password.vue'
import FormSelect from './components/form/Select.vue'
import FormSelectNew from './components/form/SelectNew.vue'
import FormCondition from './components/form/Condition.vue'
import FormChecklist from './components/form/Checklist.vue'
import FormCheckbox from './components/form/Checkbox.vue'
import FormCountries from './components/form/Countries.vue'
import FormColor from './components/form/Color.vue'
import FormScopes from './components/form/Scopes.vue'
import FormColorPicker from './components/form/ColorPicker.vue'
import FormAutocomplete from './components/form/Autocomplete.vue'
import FormDropdown from './components/form/Dropdown.vue'
import FormTag from './components/form/Tag.vue'
import Languages from './components/Languages.vue'
import Scopes from './components/Scopes.vue'
import Entity from './components/Entity.vue'
import Invoice from './components/Invoice.vue'
import Timeline from './components/Timeline.vue'
import ActionsDropdown from './components/ActionsDropdown.vue'
//import Modal from './components/Modal.vue'

//import Timeselector from 'vue-timeselector';
//import VueTimepicker from 'vue2-timepicker'

Vue.use(VueResource);

import FullCalendar from '@fullcalendar/vue'


import Paginator from './components/Paginator.vue'

import Header from './layouts/Header.vue'

import draggable from 'vuedraggable'

import VueDragResize from 'vue-drag-resize'

import { Chrome } from 'vue-color'

import VuePrismEditor from "vue-prism-editor";

import VueTelInput from 'vue-tel-input'

import VueTimepicker from 'vue2-timepicker'

import moment from 'moment'
require('moment/locale/fr');
require('moment-timezone');
//moment.locale('fr');
moment.tz.setDefault("UTC");

window.moment = moment;

//Vue.component('modal', Modal);
Vue.use(VueTelInput);
//Vue.prototype.moment = moment
Vue.component('shipping-type', ShippingType);
Vue.component('icon', Icon);
Vue.component('datagrid-sort', DatagridSort);
Vue.component('breadcrumb', BreadCrumb);
Vue.component('order-status', OrderStatus);
Vue.component('vue-timepicker', VueTimepicker);
Vue.component('full-calendar', FullCalendar);
Vue.component('prism-editor', VuePrismEditor);
Vue.component('filters', Filters);
Vue.component('no-results', NoResults);
Vue.component('advanced-filters', AdvancedFilters);
Vue.component('chrome-picker', Chrome);
Vue.component('scopes', Scopes);
Vue.component('languages', Languages);
Vue.component('draggable', draggable);
Vue.component('acl', Acl);
Vue.component('acl-authorizations', AclAuthorizations);
Vue.component('button-action', Button);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('notice-published', NoticePublished);
Vue.component('published', Published);
Vue.component('product-type', ProductType);
Vue.component('checked', Checked);
Vue.component('compare', Compare);
Vue.component('date', Date);
Vue.component('datetime', Datetime);
Vue.component('schedule', Schedule);
Vue.component('active', Active);
Vue.component('widget-dropdown', WidgetDropdown);
Vue.component('form-medias', FormMedias);
Vue.component('form-scopes', FormScopes);
Vue.component('form-code', FormCode);
Vue.component('form-editor', FormEditor);
Vue.component('form-toggle', FormToggle);
Vue.component('form-publication-state', FormPublicationState);
Vue.component('form-datex', FormDateX);
Vue.component('form-datetime', FormDatetime);
Vue.component('form-date', FormDate);
Vue.component('form-text', FormText);
Vue.component('form-address', FormAddress);
Vue.component('form-branch', FormBranch);
Vue.component('form-barcode', FormBarcode);
Vue.component('form-time', FormTime);
Vue.component('form-phone', FormPhone);
Vue.component('form-sort', FormSort);
Vue.component('form-numeric', FormNumeric);
Vue.component('form-number', FormNumber);
Vue.component('form-file', FormFile);
Vue.component('form-file-import', FormFileImport);
Vue.component('form-textarea', FormTextarea);
Vue.component('form-html', FormHtml);
Vue.component('form-select', FormSelect);
Vue.component('form-select-new', FormSelectNew);
Vue.component('form-countries', FormCountries);
Vue.component('form-color', FormColor);
Vue.component('form-color-picker', FormColorPicker);
Vue.component('form-condition', FormCondition);
Vue.component('form-checklist', FormChecklist);
Vue.component('form-checkbox', FormCheckbox);
Vue.component('form-password', FormPassword);
Vue.component('form-autocomplete', FormAutocomplete);
Vue.component('form-dropdown', FormDropdown);
Vue.component('form-tag', FormTag);
Vue.component('component-paginator', Paginator);
Vue.component('component-multiselect', Multiselect);
Vue.component('app-header', Header);
Vue.component('form-gallery', FormGallery);
Vue.component('vue-drag-resize', VueDragResize);
Vue.component('entity', Entity);
Vue.component('invoice', Invoice);
Vue.component('timeline', Timeline);
Vue.component('actions-dropdown', ActionsDropdown);

//Vue.component('timeselector', Timeselector);
//Vue.component('vue-timepicker', VueTimepicker);

Vue.component('v-style', {
    render: function (createElement) {
        return createElement('style', this.$slots.default)
    }
});

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his childrens
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

import SortableTree from './components/Tree.vue'
Vue.component(SortableTree.name, SortableTree)

var numeral = require("numeral");
numeral.register('locale', 'fr', {
    delimiters: {
        thousands: "'",
        decimal: '.'
    }
});
numeral.locale('fr');

Vue.filter("formatNumber", function (value, format) {
    value = parseFloat(value);
    if( value === null || value === undefined ){ return value; }
    var format = format || "0,0.00"
    return numeral(value).format(format);
});
Vue.filter("formatDate", function (value, format) {
    if( value === null || value === undefined ){ return value; }
    var dateFormat = require('dateformat');
    let date = new Date(value)
    var format = format || 'dd.mm.yyyy HH:MM:ss'
    return dateFormat(date, format);
});

Vue.filter("roundNumber", function(value){
    return Number((value).toFixed(1));
});

const plugins = {
    install() {
        Vue.helpers = helpers;
        Vue.prototype.$helpers = helpers;
    }
}
Vue.use(plugins);

Vue.prototype.$iconFolder = "/src/assets/icons/default/";
Vue.prototype.$iconInterface = "/src/assets/icons/dualtone/";

Array.prototype.sortOn = function(key){
    this.sort(function(a, b){
        if(a[key] < b[key]){
            return -1;
        }else if(a[key] > b[key]){
            return 1;
        }
        return 0;
    });
}

window.hexToRGBA = function(hex, opacity) {
    return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length/3 + '})', 'g')).map(function(l) { return parseInt(hex.length%2 ? l+l : l, 16) }).concat(opacity||1).join(',') + ')';
}

new Vue({
    el: '#app',
    router,
    store: store,
    template: '<App/>',
    components: { App },
    computed: {

    }
})




// WEBPACK FOOTER //
// ./src/main.js